// extracted by mini-css-extract-plugin
export var container = "_sh-0";
export var table = "_sh-2";
export var tableWrapper = "_sh-1";